import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import Icon from '../../../images/icon-success.inline.svg';
import media from '../../../utils/mediaQueries';
import { FONT_FAMILY_MAIN, TEXT_COLOR } from '../../../theme';
import { ShareReviewMessage } from '../ShareReviewMessage';

const Container = styled.div`
  padding: 24px;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  
  ${media.mobile`
    height: auto;
  `}
`;

const IconSuccess = styled(Icon)`
  width: 48px;
  height: 48px;
  
  ${media.mobile`
    width: 32px;
    height: 32px;
  `}
`;

const Title = styled.h4`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
  margin: 32px 0 8px;
  
  ${media.mobile`
    font-size: 18px;
    line-height: 1.44;
    margin-top: 8px;
  `}
`;

const Message = styled.div`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
  max-width: 437px;
  margin: 0 auto;
  
  & + & {
    margin-top: 48px;
  }
`;

type SuccessMessageProps = {
  text: string,
  placeId?: string,
  rating?: string | number,
  reviewId?: string,
  isExamCenter?: boolean,
  title?: string,
  partnerName?: string,
};

const SuccessMessage = ({
  text, placeId, rating, reviewId, isExamCenter = false, title, partnerName,
}: SuccessMessageProps) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView();
    }
  }, []);

  return (
    <>
      <Container ref={containerRef}>
        <section>
          <IconSuccess />
          <Title>{title}</Title>
          <Message>{text}</Message>
          {placeId && reviewId && rating > 3 && (
            <Message>
              <ShareReviewMessage reviewId={reviewId} isExamCenter={isExamCenter} partnerName={partnerName} />
            </Message>
          )}
        </section>
      </Container>
    </>
  );
};

SuccessMessage.defaultProps = {
  placeId: null,
  rating: 0,
  reviewId: '',
  isExamCenter: false,
  title: 'Merci pour votre avis!',
  partnerName: '',
};

export { SuccessMessage };
